import React from "react";
import { useGetPackagingMaterial } from "../../../../../api/static-data";
import {
  ApiPackagingLevelType,
  PackagingLevelViewModel,
  PackagingUnitFieldKey,
  PackagingUnitSnapshot
} from "../types/packagingDetail.types";
import { MaterialFormValues } from "../types/packagingMaterial.types";
import PackagingLevelSection from "./PackagingLevelSection";

interface PackagingLevelTableProps {
  levels: PackagingLevelViewModel[];
  onAddMaterial: (level: ApiPackagingLevelType, values: MaterialFormValues) => void;
  onUpdateMaterial: (level: ApiPackagingLevelType, materialId: string, values: MaterialFormValues) => void;
  onRemoveMaterial: (level: ApiPackagingLevelType, materialId: string) => void;
  onSaveUnit: (fieldKey: PackagingUnitFieldKey, patch: Partial<PackagingUnitSnapshot>) => void;
  disabled?: boolean;
}

const PackagingLevelTable: React.FC<PackagingLevelTableProps> = ({
  levels,
  onAddMaterial,
  onUpdateMaterial,
  onRemoveMaterial,
  onSaveUnit,
  disabled = false
}) => {
  const { data: packagingTypeData } = useGetPackagingMaterial();

  return (
    <div className="tw-space-y-2">
      {levels.map(level => (
        <PackagingLevelSection
          key={level.key}
          level={level}
          packagingTypeData={packagingTypeData ?? []}
          onAddMaterial={onAddMaterial}
          onUpdateMaterial={onUpdateMaterial}
          onRemoveMaterial={onRemoveMaterial}
          onSaveUnit={patch => onSaveUnit(level.unitFieldKey, patch)}
          disabled={disabled}
        />
      ))}
    </div>
  );
};

export default PackagingLevelTable;
